import { render, staticRenderFns } from "./RuleDescription.vue?vue&type=template&id=5a268c76&"
import script from "./RuleDescription.vue?vue&type=script&lang=js&"
export * from "./RuleDescription.vue?vue&type=script&lang=js&"
import style0 from "./RuleDescription.vue?vue&type=style&index=0&id=5a268c76&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports